import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
} from "react-router-dom";
import { getAllUniplexByIdJardin } from "../../API/ApiUniplex";
import { AuthContext } from "../../auth/authContext";
import { AddUniplexScreenComponent } from "../../Components/AddUniplexScreenComponent/AddUniplexScreenComponent";
import AddIcon from "@mui/icons-material/Add";
import ErrorIcon from "@mui/icons-material/Error";
import { AsignarFallecidosAEspacioUniplexComponent } from "../../Components/AsignarFallecidosAEspacioUniplexComponent/AsignarFallecidosAEspacioUniplexComponent";
import { AsignarContratoAEspacioUniplexComponent } from "../../Components/AsignarContratoAEspacioUniplexComponent/AsignarContratoAEspacioUniplexComponent";
import { getAllDuplexByIdJardin } from "../../API/ApiDuplex";
import { AddDuplexScreenComponent } from "../../Components/AddDuplexScreenComponent/AddDuplexScreenComponent";
import { AsignarFallecidosAEspacioDuplexComponent } from "../../Components/AsignarFallecidosAEspacioDuplexComponent/AsignarFallecidosAEspacioDuplexComponent";
import { AsignarContratoAEspacioDuplexComponent } from "../../Components/AsignarContratoAEspacioDuplexComponent/AsignarContratoAEspacioDuplexComponent";
import { getAllMuralesByIdJardin } from "../../API/ApiMurales";
import { AddMuralesScreenComponent } from "../../Components/AddMuralesScreenComponent/AddMuralesScreenComponent";
import { AsignarFallecidosAEspacioMuralesComponent } from "../../Components/AsignarFallecidosAEspacioMuralesComponent/AsignarFallecidosAEspacioMuralesComponent";
import { AsignarContratoAEspacioMuralesComponent } from "../../Components/AsignarContratoAEspacioMuralesComponent/AsignarContratoAEspacioMuralesComponent";
import { checkPermisosPorUsuarioPorGuidPantalla } from "../../API/ApiPermisos";
import { getAllMausoleoByIdJardin } from "../../API/ApiMausoleo";
import { AddMausoleoScreenComponent } from "../../Components/AddMausoleoScreenComponent/AddMausoleoScreenComponent";
import { AsignarFallecidoAMausoleoScreenComponent } from "../../Components/AsignarFallecidoAMausoleoScreenComponent/AsignarFallecidoAMausoleoScreenComponent";
import { AsignarContratoAEspacioMausoleoComponent } from "../../Components/AsignarContratoAEspacioMausoleoComponent/AsignarContratoAEspacioMausoleoComponent";
import { EditMausoleoScreenComponent } from "../../Components/EditMausoleoScreenComponent/EditMausoleoScreenComponent";
import { EditarFallecidoAMausoleoScreenComponent } from "../../Components/EditarFallecidoAMausoleoScreenComponent/EditarFallecidoAMausoleoScreenComponent";
import { AsignarFechaDeinicioDePagoaEspacioComponent } from "./../../Components/AsignarFechaDeinicioDePagoaEspacioComponent/AsignarFechaDeinicioDePagoaEspacioComponent";
import CachedIcon from "@mui/icons-material/Cached";
const guidVista = "6b203d5f-1db7-4edf-a929-d8e21c15e9aa";

export const MausoleoScreenComponent = () => {
  const { user, dispatch } = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(true);
  const [finalData, setFinalData] = React.useState({
    totalEspacios: 0,
    totalEspaciosConContrato: 0,
    totalPersonasMuertas: 0,
    data: [],
  });

  let { jardin } = useParams();

  jardin = JSON.parse(jardin);

  const [crudAction, setCrudAction] = React.useState({
    action: null,
    data: null,
  });

  const [asignarPersonaMural, setAsignarPersonaMural] = React.useState(false);
  const [agregarMural, setAgregarMural] = React.useState(false);
  const [asignarContratoMural, setAsignarContratoMural] = React.useState(false);

  const [checkPersmissions, setCheckPermissions] = React.useState([]);

  React.useEffect(() => {
    let ready = false;

    checkPermisosPorUsuarioPorGuidPantalla(user, guidVista).then(
      (resultado) => {
        if (resultado.status == 200) {
          setCheckPermissions(resultado.data);

          for (const permiso of resultado.data) {
            if (
              permiso.guidFuncion == "7b45cd41-d68b-4a36-947d-cee457842ad1" &&
              permiso.allowed == 1
            ) {
              setAsignarPersonaMural(true);
            }
            if (
              permiso.guidFuncion == "424ab4c6-ed37-45c7-86c9-ed8c001388d0" &&
              permiso.allowed == 1
            ) {
              setAgregarMural(true);
            }
            if (
              permiso.guidFuncion == "41dbba86-4d75-4790-b6d9-486b1e092e37" &&
              permiso.allowed == 1
            ) {
              setAsignarContratoMural(true);
            }
          }
        }
      }
    );

    return () => {
      ready = true;
    };
  }, []);

  React.useEffect(() => {
    getAllMausoleoByIdJardin(user, jardin.id).then((resultado) => {
      if (resultado.status == 200) {
        let totalEspacios = resultado.data.length;
        let totalEspaciosConContrato = 0;
        let totalPersonasMuertas = 0;

        for (const espacio of resultado.data) {
          if (espacio.contrato != null) {
            totalEspaciosConContrato = totalEspaciosConContrato + 1;
          }

          for (const urna of espacio.urna) {
            totalPersonasMuertas = totalPersonasMuertas + 1;
          }
        }

        let armandoFinal = {
          totalEspacios: totalEspacios,
          totalEspaciosConContrato: totalEspaciosConContrato,
          totalPersonasMuertas: totalPersonasMuertas,
          data: resultado.data,
        };

        setFinalData(armandoFinal);
      } else {
        setFinalData([]);
      }
    });
  }, [crudAction]);

  return (
    <>
      {agregarMural == true ? (
        <>
          {" "}
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12 text-end my-3">
                <button
                  className="btn btn-sm btn-success"
                  onClick={() => {
                    setCrudAction({
                      action: "add",
                      data: null,
                    });
                  }}
                >
                  Agregar Mausoleo
                </button>
              </div>
            </div>
          </div>
        </>
      ) : null}

      <div className="container-fluid mt-3 mb-3">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="container-fluid">
                  <div className="row row-cols-md-4">
                    <div className="col text-center">
                      <h6>Espacios Creados</h6>
                      <strong> {finalData.totalEspacios}</strong>
                    </div>
                    <div className="col text-center">
                      <strong>
                        <h6>Espacios Con Contrato Asignado</h6>
                        {finalData.totalEspaciosConContrato}
                      </strong>
                    </div>
                    <div className="col text-center">
                      <strong>
                        <h6>Espacios Sin Contrato Asignado</h6>
                        {finalData.totalEspacios -
                          finalData.totalEspaciosConContrato}
                      </strong>
                    </div>
                    <div className="col text-center">
                      <strong>
                        <h6>Fallecidos totales en espacio</h6>
                        {finalData.totalPersonasMuertas}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div
          className="row row-cols-md-4"
          data-masonry='{"percentPosition": true }'
        >
          {finalData.data.map((uniplex, index) => (
            <div key={index} className="col">
              <div className="card mb-3">
                <div className="card-header d-flex justify-content-between d-flex align-items-center">
                  <strong>
                    {uniplex.ejeX}
                    {uniplex.ejeY}
                  </strong>
                  <strong>
                    {uniplex.contrato == null ? (
                      <>
                        <ErrorIcon /> Sin Contrato
                      </>
                    ) : (
                      <a
                        href={`/contrato/${uniplex.idcontrato}/false`}
                        target={"_self"}
                        rel="noreferrer"
                      >
                        <i>
                          {uniplex.contrato == null
                            ? "Sin Contrato"
                            : uniplex.contrato}
                        </i>
                      </a>
                    )}
                  </strong>
                  {asignarContratoMural == true ? (
                    <>
                      <div>
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => {
                            setCrudAction({
                              action: "asignarContrato",
                              data: uniplex,
                            });
                          }}
                        >
                          <span>
                            <AddIcon /> Contrato
                          </span>
                        </button>
                        <br />
                        <button
                          className="btn btn-sm btn-outline-success mt-2"
                          onClick={() => {
                            setCrudAction({
                              action: "actualizarFecha",
                              data: uniplex,
                            });
                          }}
                        >
                          <span>
                            <CachedIcon /> Fecha
                          </span>
                        </button>
                      </div>
                    </>
                  ) : null}
                </div>
                <div className="card-body">
                  <ul className="list-group list-group-flush ">
                    <li className="list-group-item w-100">
                     Asignación:  {uniplex.fechaAsignacion == null ? 'Sin Fecha' : uniplex.fechaAsignacion}
                     <br />
                    </li>
                    {uniplex.urna.map((urna) => (
                      <>
                        <li className="list-group-item  w-100">
                          {urna.urna} <br />
                          Entrada: {urna.fechaEntrada} <br />
                          {urna.fechaSalida == null ? null : (
                            <React.Fragment>
                              Salida: {urna.fechaSalida}
                              <br />
                            </React.Fragment>
                          )}
                          {uniplex.idcontrato == 0 ? null : (
                            <React.Fragment>
                              <div
                                className="btn btn-sm btn-success m-0"
                                onClick={() => {
                                  setCrudAction({
                                    action: "editarMausoleo",
                                    data: urna,
                                  });
                                }}
                              >
                                Modificar
                              </div>
                            </React.Fragment>
                          )}
                        </li>
                      </>
                    ))}
                  </ul>
                </div>
                <div className="card-footer">
                  {asignarPersonaMural == true ? (
                    <>
                      {" "}
                      {uniplex.idcontrato == null ? (
                        <>
                          {" "}
                          <button
                            className="btn btn-sm btn-outline-success w-100"
                            onClick={() => {
                              setCrudAction({
                                action: "asignarContrato",
                                data: uniplex,
                              });
                            }}
                          >
                            <span>
                              <AddIcon /> Contrato
                            </span>
                          </button>{" "}
                        </>
                      ) : (
                        <>
                          {uniplex.idcontrato == 0 ? null : (
                            <React.Fragment>
                              <button
                                className="btn btn-sm btn-outline-success w-100"
                                onClick={() => {
                                  setCrudAction({
                                    action: "asignFallecido",
                                    data: uniplex,
                                  });
                                }}
                              >
                                Asignar
                              </button>
                            </React.Fragment>
                          )}
                        </>
                      )}
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {crudAction.action == "add" ? (
        <>
          <AddMausoleoScreenComponent
            crudAction={crudAction}
            setCrudAction={setCrudAction}
            jardin={jardin}
          />
        </>
      ) : null}
      {crudAction.action == "editarMausoleo" ? (
        <>
          <EditarFallecidoAMausoleoScreenComponent
            crudAction={crudAction}
            setCrudAction={setCrudAction}
            jardin={jardin}
          />
        </>
      ) : null}

      {crudAction.action == "asignFallecido" ? (
        <>
          <AsignarFallecidoAMausoleoScreenComponent
            crudAction={crudAction}
            setCrudAction={setCrudAction}
            jardin={jardin}
          />
        </>
      ) : null}
      {crudAction.action == "asignarContrato" ? (
        <>
          <AsignarContratoAEspacioMausoleoComponent
            crudAction={crudAction}
            setCrudAction={setCrudAction}
            jardin={jardin}
          />
        </>
      ) : null}

      {crudAction.action == "actualizarFecha" ? (
        <>
          <AsignarFechaDeinicioDePagoaEspacioComponent
            crudAction={crudAction}
            setCrudAction={setCrudAction}
            idEspacio={4}
          />
        </>
      ) : null}
    </>
  );
};
